import {Observable, of} from 'rxjs';
import {Injectable} from '@angular/core';

@Injectable()
export class DialogService {
    confirm(message?: string): Observable<boolean> {
        const confirmation = window.confirm(message);
        return of(confirmation);
    }
}
